import type { Subtask } from './types'

export function createSubtaskDuplicate(subtask: Subtask, id: string, createdBy: string): Subtask {
  return {
    ...subtask,
    id,
    title: `${subtask.title} — cópia`,
    createdBy,
    status: 'Em espera',
    seconds: 0,
    running: false,
    timeEntries: [],
    completedAt: undefined,
    analysisApprovedAt: undefined,
    analysisApprovedBy: undefined,
  }
}
